import { css } from 'lit';

export default css`
  :host {
    display: block;
    font-family: var(--font-family-base, Inter, Helvetica, sans-serif);
    font-optical-sizing: auto;
    color: var(--base-text-color);
  }

  .text {
    margin: 0;
  }

  /* Headlines */
  :host([variant="h1"]) .text {
    font-size: var(--font-size-h1, 48px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-h1, 58px);
    letter-spacing: 0;
  }

  :host([variant="h2"]) .text {
    font-size: var(--font-size-h2, 40px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-h2, 48px);
    letter-spacing: 0;
  }

  :host([variant="h3"]) .text {
    font-size: var(--font-size-h3, 32px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-h3, 38px);
    letter-spacing: 0;
  }

  :host([variant="h4"]) .text {
    font-size: var(--font-size-h4, 28px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-h4, 34px);
    letter-spacing: 0;
  }

  :host([variant="h5"]) .text {
    font-size: var(--font-size-h5, 24px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-h5, 28px);
    letter-spacing: 0;
  }

  /* Subtitles */
  :host([variant="s1-subtitle"]) .text {
    font-size: var(--font-size-s1, 18px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-s1, 28px);
    letter-spacing: 0;
  }

  :host([variant="s2-subtitle"]) .text {
    font-size: var(--font-size-s2, 16px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-s2, 24px);
    letter-spacing: 0;
  }

  /* Body */
  :host([variant="b1-body"]) .text {
    font-size: var(--font-size-b1, 16px);
    font-weight: var(--font-weight-regular, 400);
    line-height: var(--line-height-b1, 24px);
    letter-spacing: 0;
  }

  :host([variant="b2-body"]) .text {
    font-size: var(--font-size-b2, 16px);
    font-weight: var(--font-weight-medium, 500);
    line-height: var(--line-height-b2, 24px);
    letter-spacing: 0;
  }

  :host([variant="b3-body"]) .text {
    font-size: var(--font-size-b3, 14px);
    font-weight: var(--font-weight-regular, 400);
    line-height: var(--line-height-b3, 20px);
    letter-spacing: 0;
  }

  :host([variant="b4-body"]) .text {
    font-size: var(--font-size-b4, 14px);
    font-weight: var(--font-weight-medium, 500);
    line-height: var(--line-height-b4, 20px);
    letter-spacing: 0;
  }

  /* Captions */
  :host([variant="c1-caption"]) .text {
    font-size: var(--font-size-c1, 12px);
    font-weight: var(--font-weight-regular, 400);
    line-height: var(--line-height-c1, 16px);
    letter-spacing: 0;
  }

  :host([variant="c2-caption"]) .text {
    font-size: var(--font-size-c2, 12px);
    font-weight: var(--font-weight-medium, 500);
    line-height: var(--line-height-c2, 16px);
    letter-spacing: 0;
  }

  :host([variant="c3-caption"]) .text {
    font-size: var(--font-size-c3, 10px);
    font-weight: var(--font-weight-medium, 500);
    line-height: var(--line-height-c3, 14px);
    letter-spacing: 0;
  }

  /* Label */
  :host([variant="label"]) .text {
    font-size: var(--font-size-label, 12px);
    font-weight: var(--font-weight-medium, 500);
    line-height: var(--line-height-label, 16px);
    letter-spacing: 0;
  }

  /* Button Sizes */
  :host([variant="button-giant"]) .text {
    font-size: var(--font-size-button-giant, 18px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-button-giant, 24px);
    letter-spacing: 0;
  }

  :host([variant="button-large"]) .text {
    font-size: var(--font-size-button-large, 16px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-button-large, 20px);
    letter-spacing: 0;
  }

  :host([variant="button-medium"]) .text {
    font-size: var(--font-size-button-medium, 14px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-button-medium, 16px);
    letter-spacing: 0;
  }

  :host([variant="button-small"]) .text {
    font-size: var(--font-size-button-small, 12px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-button-small, 16px);
    letter-spacing: 0;
  }

  :host([variant="button-tiny"]) .text {
    font-size: var(--font-size-button-tiny, 10px);
    font-weight: var(--font-weight-semibold, 600);
    line-height: var(--line-height-button-tiny, 12px);
    letter-spacing: 0;
  }

  :host([font]) .text {
    font-family: var(--font, inherit);
  }
  :host([color]) .text {
    color: var(--color, inherit);
  }
`;